import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { AppErrorBoundary } from './components/AppErrorBoundary';
import './index.css';

// A deploy replaces every hashed chunk, so a tab opened before it 404s the
// first time it lazy-loads one (e.g. the voice chunk on "Join"). Vite reports
// that as `vite:preloadError`; reload onto the new build instead of landing on
// the crash screen. Guarded so a genuinely missing chunk can't reload-loop.
// Voice state + the rejoin marker persist, so VoiceRejoinPrompt picks up.
window.addEventListener('vite:preloadError', (event) => {
  const KEY = 'chatapp-chunk-reload-at';
  let last = 0;
  try { last = Number(sessionStorage.getItem(KEY) ?? 0); } catch { /* storage blocked */ }
  if (Date.now() - last < 30_000) return; // already tried — let it surface
  try { sessionStorage.setItem(KEY, String(Date.now())); } catch { /* ignore */ }
  event.preventDefault();
  window.location.reload();
});

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('No #root element');

createRoot(rootEl).render(
  <StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </StrictMode>
);

// Register the push service worker (no-op if unsupported). Required for Web
// Push delivery; subscribing itself is opt-in via Settings → Notifications.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
